
import { useEffect, useState } from 'react';
import { Capacitor } from '@capacitor/core';

interface SafeAreaInsets {
  top: number;
  bottom: number;
  left: number;
  right: number;
}

export const useIOSSafeArea = () => {
  const [safeAreaInsets, setSafeAreaInsets] = useState<SafeAreaInsets>({
    top: 0,
    bottom: 0,
    left: 0,
    right: 0
  });
  const [isIOS, setIsIOS] = useState(false);

  useEffect(() => {
    const platform = Capacitor.getPlatform();
    const isIOSPlatform = platform === 'ios';
    setIsIOS(isIOSPlatform);

    if (isIOSPlatform) {
      // Get safe area insets from CSS custom properties
      const updateSafeAreaInsets = () => {
        const computedStyle = getComputedStyle(document.documentElement);
        
        const top = parseInt(computedStyle.getPropertyValue('--safe-area-inset-top').replace('px', '')) || 0;
        const bottom = parseInt(computedStyle.getPropertyValue('--safe-area-inset-bottom').replace('px', '')) || 0;
        const left = parseInt(computedStyle.getPropertyValue('--safe-area-inset-left').replace('px', '')) || 0;
        const right = parseInt(computedStyle.getPropertyValue('--safe-area-inset-right').replace('px', '')) || 0;

        setSafeAreaInsets({ top, bottom, left, right });
        
        // Debug logging for iOS safe areas
        console.log('iOS Safe Area Insets:', { top, bottom, left, right });
      };

      // Update on mount
      updateSafeAreaInsets();

      // Update on orientation change or resize
      window.addEventListener('resize', updateSafeAreaInsets);
      window.addEventListener('orientationchange', updateSafeAreaInsets);

      return () => {
        window.removeEventListener('resize', updateSafeAreaInsets);
        window.removeEventListener('orientationchange', updateSafeAreaInsets);
      };
    }
  }, []);

  const enableSafeAreaDebug = () => {
    if (isIOS) {
      document.body.classList.add('debug-safe-area');
      console.log('iOS Safe Area Debug enabled');
    }
  };

  const disableSafeAreaDebug = () => {
    document.body.classList.remove('debug-safe-area');
    console.log('iOS Safe Area Debug disabled');
  };

  return {
    safeAreaInsets,
    isIOS,
    enableSafeAreaDebug,
    disableSafeAreaDebug
  };
};
